'use client'

import { useSearchStore } from '@stores/search.store'

import { useEffect, useState } from 'react'

import type { JobPageItem, JobSearch } from '@types'

import PageViewEvent from 'src/app/page-view-event'

import { emailDailyRecommendationsRedirectEvent, jobPageViewEvent } from '@lib/analytics-events'
import { sendGTMEvent } from '@lib/helpers/client'

type PageEventProps = {
  job: JobPageItem
  search: JobSearch
}

export default function PageEvent({ job, search }: PageEventProps): JSX.Element {
  const serpPositionClicked = useSearchStore((state) => state.serpPositionClicked)
  const [eventSent, setEventSent] = useState<boolean>(false)

  useEffect(() => {
    if (!eventSent) {
      if (search.dailyApply) {
        emailDailyRecommendationsRedirectEvent(search, parseInt(search.dailyApply, 10) + 1, job)
      }
      window?.dataLayer?.push?.({ 'Job ID': job.id })
      sendGTMEvent('jobPageOpened')
      jobPageViewEvent(job, search, String(serpPositionClicked))
      setEventSent(true)
    }
  }, [job, search, serpPositionClicked, eventSent])
  return <PageViewEvent location="job" />
}
